/**
 * Where maître d'AI's panel shows. On a wide screen it is the lane beside the
 * page, or the drawer over it once the lane is closed. Narrow (up to
 * `ASK_NARROW_QUERY`), it is never a column: only the drawer, over the page
 * (a full-screen sheet on a phone), and only when it was opened there; the
 * lane state persisted from a wide screen is ignored, so it can't lock a
 * phone into the panel.
 */
export const ASK_NARROW_QUERY = '(max-width: 1100px)';

export function askSurface({
  agentOpen,
  agentLaneOpen,
  narrow,
  mode,
}: {
  agentOpen: boolean;
  agentLaneOpen: boolean;
  narrow: boolean;
  mode: string;
}): { lane: boolean; drawer: boolean } {
  if (mode === 'assistant') return { lane: false, drawer: false };
  if (narrow) return { lane: false, drawer: agentOpen };
  return { lane: agentLaneOpen, drawer: agentOpen && !agentLaneOpen };
}
